import Dashboard from '../views/dashboard/Dashboard.vue';
import Login from '../views/auth/Login.vue';
import DestinationTypeList from '../views/master-data/destination-type/DestinationTypeList.vue';
import DestinationTypeForm from '../views/master-data/destination-type/DestinationTypeForm.vue';
import DistrictList from '../views/master-data/district/DistrictList.vue';
import DistrictForm from '../views/master-data/district/DistrictForm.vue';
import DestinationList from '../views/destination/destination/DestinationList.vue';
import DestinationForm from '../views/destination/destination/DestinationForm.vue';
import BlogList from '../views/blog/blog/BlogList.vue';
import BlogForm from '../views/blog/blog/BlogForm.vue';
import EventList from '../views/event/event/EventList.vue';
import EventForm from '../views/event/event/EventForm.vue';
import AnnouncementList from '../views/announcement/announcement/AnnouncementList.vue';
import AnnouncementForm from '../views/announcement/announcement/AnnouncementForm.vue';
import UserSystemList from '../views/setting/user-system/UserSystemList.vue';
import UserSystemForm from '../views/setting/user-system/UserSystemForm.vue';
import UserClientList from '../views/setting/user-client/UserClientList.vue';
import UserClientForm from '../views/setting/user-client/UserClientForm.vue';
import ProfilePage from '../views/other/ProfilePage.vue';
import ChangePasswordPage from '../views/other/ChangePasswordPage.vue';
import Error404 from '../views/error/404.vue';
import PercobaanPage from '../views/other/PercobaanPage.vue';

const routes = [
  {
    path: '/app',
    redirect: '/app/dashboard',
    meta: {
      layout: 'app',
      requiredAuth: true,
    },
    children: [
      {
        path: '/app/dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },
      // DESTINATION TYPE
      {
        path: '/app/master-data/destination-type',
        name: 'DestinationTypeList',
        component: DestinationTypeList,
      },
      {
        path: '/app/master-data/destination-type/form',
        name: 'DestinationTypeForm',
        component: DestinationTypeForm,
      },
      // DISTRICT
      {
        path: '/app/master-data/district',
        name: 'DistrictList',
        component: DistrictList,
      },
      {
        path: '/app/master-data/district/form',
        name: 'DistrictForm',
        component: DistrictForm,
      },
      // DESTINATION
      {
        path: '/app/destination/destination',
        name: 'DestinationList',
        component: DestinationList,
      },
      {
        path: '/app/destination/destination/form',
        name: 'DestinationForm',
        component: DestinationForm,
      },
      // BLOG
      {
        path: '/app/blog/blog',
        name: 'BlogList',
        component: BlogList,
      },
      {
        path: '/app/blog/blog/form',
        name: 'BlogForm',
        component: BlogForm,
      },
      // EVENT
      {
        path: '/app/event/event',
        name: 'EventList',
        component: EventList,
      },
      {
        path: '/app/event/event/form',
        name: 'EventForm',
        component: EventForm,
      },
      // ANNOUNCEMENT
      {
        path: '/app/announcement/announcement',
        name: 'AnnouncementList',
        component: AnnouncementList,
      },
      {
        path: '/app/announcement/announcement/form',
        name: 'AnnouncementForm',
        component: AnnouncementForm,
      },
      // USER SYSTEM
      {
        path: '/app/setting/user-system',
        name: 'UserSystemList',
        component: UserSystemList,
      },
      {
        path: '/app/setting/user-system/form',
        name: 'UserSystemForm',
        component: UserSystemForm,
      },
      // USER CLIENT
      {
        path: '/app/setting/user-client',
        name: 'UserClientList',
        component: UserClientList,
      },
      {
        path: '/app/setting/user-client/form',
        name: 'UserClientForm',
        component: UserClientForm,
      },
      // PROFILE
      {
        path: '/app/other/profile',
        name: 'ProfilePage',
        component: ProfilePage,
      },
      // CHANGE PASSWORD
      {
        path: '/app/other/change-password',
        name: 'ChangePasswordPage',
        component: ChangePasswordPage,
      },
      // PERCOBAAN
      {
        path: '/app/other/percobaan',
        name: 'PercobaanPage',
        component: PercobaanPage,
      },
    ],
  },
  //-----------------------------------------------------
  {
    path: '/',
    name: 'Index',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      layout: 'auth',
      requiredUnauth: true,
    },
  },
  {
    path: '/:notFound(.*)',
    component: Error404,
    meta: {
      layout: 'auth',
    },
  },
];

export default routes;
